import React from 'react';
import { Button, Popconfirm, Space, Table } from 'antd';
import {
  useDeleteNakshatram,
  useGetAllNakshatrams,
} from '../../services/nakshatram/nakshatram.service.hook';
import TmsNakshatramCreateModal from './tms-nakshatram-create-modal';
import { withRouter } from '../../utils/tms-with-router/tms-with-router';

const TMSNakshatramManagement = ({ router }) => {
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);

  const { data: nakshatrams, isLoading } = useGetAllNakshatrams(page, limit);

  const { mutate: deleteNakshatram, isPending: isDeleteLoading } =
    useDeleteNakshatram();

  const [showCreateModal, setShowCreateModal] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  const handleEdit = (record) => {
    setEditData(record);
    setShowCreateModal(true);
  };

  const handleDelete = (record) => {
    deleteNakshatram({ nakshatramId: record.id });
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size='middle'>
          <a
            onClick={() => {
              router.navigate(`/nakshatram/${record.id}/sub-temple`);
            }}
          >
            Sub Temples
          </a>
          <a onClick={() => handleEdit(record)}>Edit</a>
          <Popconfirm
            title='Are you sure？'
            okText='Yes'
            cancelText='No'
            onConfirm={() => handleDelete(record)}
          >
            <a style={{ color: 'red' }}>Delete</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ float: 'left', marginBottom: '5px' }}>
        <Button onClick={() => setShowCreateModal(true)} type='primary'>
          Create Nakshatram
        </Button>
      </div>
      <div>
        <Table
          size='small'
          columns={columns}
          dataSource={nakshatrams?.items}
          loading={isLoading || isDeleteLoading}
          onChange={handleTableChange}
          pagination={{
            current: page,
            pageSize: limit,
            total: nakshatrams?.meta?.totalItems,
          }}
        />
      </div>
      <TmsNakshatramCreateModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        editData={editData}
      />
    </>
  );
};

export default withRouter(TMSNakshatramManagement);
